import { Box, GridItem, Image } from "@chakra-ui/react"
import { Text } from "@/components"
import { Resource } from "@/types"

interface Props {
  resource: Resource
}

export const ResourceGridItem = ({ resource }: Props) => {
  return (
    <GridItem
      cursor="pointer"
      bg="white"
      borderRadius={10}
      boxShadow="md"
      _hover={{ boxShadow: "lg" }}
      overflow="hidden"
      onClick={() => window.open(resource.url, "_blank", "noopener,noreferrer")}
    >
      <Box w="100%">
        <Image src={resource.photo ?? "https://images.unsplash.com/photo-1432821596592-e2c18b78144f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8YmxvZ3xlbnwwfHwwfHw%3D&w=1000&q=80"} />
      </Box>
      <Text p={5} fontSize="lg">
        { resource.title }
      </Text>
    </GridItem>
  )
}
